<template>
  <Page class="page-container--scrollable-table">
    <PageContent>
      <SealContext>
        <SealTabs />
        <RouterView />
      </SealContext>
    </PageContent>
  </Page>
</template>

<script lang="ts" setup>
import { useAccountMembershipsContext } from '@/composables/deepadmin/use-account-memberships-context.ts'
import { useAuthorizationContext } from '@/composables/deepadmin/use-authorization-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import { useCompanySealEntriesData } from '@/composables/deepsign/use-company-seals-data.ts'
import SealContext from '@/components/deepSign/sealSettings/seal/SealContext.vue'
import SealTabs from '@/components/deepSign/sealSettings/seal/SealTabs.vue'
import Page from '@/components/page/Page.vue'
import PageContent from '@/components/page/PageContent.vue'

const { permissions } = useAuthorizationContext()
const { selectedOrganizationId } = useAccountMembershipsContext()
const { showSealSettings, isSuccess } = useCompanySealEntriesData(
  selectedOrganizationId,
)

definePage({
  meta: {
    breadcrumbLabelKey: '',
  },
})

usePageAccess(
  computed(() => !permissions.canManageCertificates || !showSealSettings.value),
  '/organizations/[organizationId]/settings',
  computed(() => !isSuccess.value),
)
</script>
